import { LinearProgress, Typography } from '@mui/material';
import FlexContainer from 'components/FlexContainer';
import { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  icon: ReactNode;
  label: string;
  count: number;
  total: number;
  color: 'success' | 'warning' | 'error';
};

export const JudgmentProgressBar = ({ icon, label, count, total, color }: Props) => {
  const percentage = total > 0 ? Math.round((count / total) * 100) : 0;
  const value = total > 0 ? (count / total) * 100 : 0;

  return (
    <Root>
      <FlexContainer direction="row" alignItems="center" gap="one">
        {icon}
        <Typography variant="body2">{label}</Typography>
      </FlexContainer>

      <ProgressBarContainer>
        <StyledProgress variant="determinate" value={value} color={color} />
      </ProgressBarContainer>

      <Typography variant="body2">
        {count} ({percentage}%)
      </Typography>
    </Root>
  );
};

const Root = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr 80px;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.two};
`;

const ProgressBarContainer = styled.div`
  flex-grow: 1;
  width: 100%;
`;

const StyledProgress = styled(LinearProgress)`
  background-color: ${({ theme }) => theme.colors.palette.dark__300};
`;
